import { axios } from '@/utils/request'

const api = {
  Pre: '/admin.php/Admin/pre',
  AdminList: '/admin.php/Admin/getList',
  AdminDetail: '/admin.php/Admin/detail',
  AddAdmin: '/admin.php/Admin/add',
  UpdateAdmin: '/admin.php/Admin/update',
  DelAdmin: '/admin.php/Admin/del'
}

export function pre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function getAdminList (parameter) {
  return axios({
    url: api.AdminList,
    method: 'get',
    params: parameter
  })
}

export function getAdminDetail (parameter) {
  return axios({
    url: api.AdminDetail,
    method: 'get',
    params: {
      admin_id: parameter
    }
  })
}

export function postAdminBasicInfo (parameter) {
  return axios({
    url: api.AddAdmin,
    method: 'post',
    data: parameter
  })
}

export function postUpdateAdmin (parameter) {
  return axios({
    url: api.UpdateAdmin,
    method: 'post',
    data: parameter
  })
}

export function postDeleteAdmin (params) {
  return axios({
    url: api.DelAdmin,
    method: 'post',
    data: {
      admin_id: params
    }
  })
}
